import { DatePicker, TimePicker } from '@mui/lab';
import { Grid } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { EndPracticeVM } from 'practice/view-models/practice-detail';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';

interface AccordionEndPracticeFormProps {
  disabled?: boolean;
  values?: EndPracticeVM;
  errors?: FormikErrors<EndPracticeVM>;
  touched?: FormikTouched<EndPracticeVM>;
  onChange: (key: keyof EndPracticeVM, value: EndPracticeVM[keyof EndPracticeVM]) => void;
}

const AccordionEndPracticeFormComponent = ({
  disabled,
  values,
  onChange,
  touched,
  errors,
}: AccordionEndPracticeFormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={8}>
        <DatePicker
          label="Data inizio sospensione"
          aria-label="Data inizio sospensione"
          value={values?.startSuspensionDate || null}
          onChange={(date) => onChange('startSuspensionDate', date)}
          disabled
          renderInput={(params) => (
            <PmiTextField {...params} id="startdsuspensionDate" fullWidth helperText="" />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TimePicker
          label="Ora"
          value={values?.timeStart || null}
          onChange={(date) => {
            onChange('timeStart', date);
          }}
          disabled
          renderInput={(params) => (
            <PmiTextField id="timeStart" {...params} fullWidth helperText="" />
          )}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <DatePicker
          label="Data fine sospensione *"
          aria-label="Data fine sospensione"
          value={values?.endSuspensionDate || null}
          onChange={(date) => onChange('endSuspensionDate', date)}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="endSuspensionDate"
              fullWidth
              error={touched?.endSuspensionDate && Boolean(errors?.endSuspensionDate)}
              helperText={errors?.endSuspensionDate}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TimePicker
          label="Ora *"
          value={values?.timeEnd || null}
          onChange={(date) => {
            onChange('timeEnd', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              id="timeEnd"
              {...params}
              fullWidth
              error={touched?.timeEnd && Boolean(errors?.timeEnd)}
              helperText={errors?.timeEnd}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          id="reason"
          label="Motivo *"
          aria-label="motivo"
          fullWidth
          multiline
          rows={5}
          inputProps={{
            maxLength: '100',
          }}
          onChange={(event) => {
            onChange('reason', event.target.value);
          }}
          value={values?.reason || ''}
          error={touched?.reason && Boolean(errors?.reason)}
          helperText={errors?.reason}
        />
      </Grid>
    </Grid>
  );
};

AccordionEndPracticeFormComponent.displayName = 'Accordion end practice form component';

const AccordionEndPracticeForm = memo(AccordionEndPracticeFormComponent);

export default AccordionEndPracticeForm;
